import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo DocumentCase - 完成補件案件
 */
const CompleteDocumentCase = [
    'POST',
    RouteUrlList.API_CompleteDocumentCase.path,
    {
        HasIDFrontItem: true,
        IDCheck_Y: '112',
        IDCheck_M: '6',
        IDCheck_D: '15',
        IDCheck_P: '10003',
        IDCheck_T: '1'
    },
    200,
    {
        status: true,
        code: 0,
        exception: null,
        message: '補件案件已成功完成，身分證資訊驗證通過'
    }
];

export default CompleteDocumentCase;
